import type { BeneficialOwnerData, BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { BANK_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useBankCreateBeneficialOwner(bankId: string, dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: createBeneficialOwner, isPending: isCreatingBeneficialOwner } = useMutation({
    mutationKey: [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
    mutationFn: (beneficialOwner: BeneficialOwnerData) =>
      beneficialOwnerApi.bankCreateBeneficialOwner(bankId, dispensaryId, beneficialOwner),
    onSuccess: (createdOwner) => {
      return queryClient.setQueryData(
        [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
        (old: BeneficialOwnerResponse[] | undefined) => (old ?? []).concat(createdOwner)
      );
    },
    meta: {
      snackbarSuccessMessage: 'Beneficial owner added successfully.',
      snackbarErrorMessage: 'There was an issue adding beneficial owner.'
    }
  });

  return { createBeneficialOwner, isCreatingBeneficialOwner };
}
